const settingConfig = require('../settings.js');

import Web3 from "web3";
//import store from '@/store';
//import { createWeb3Modal, defaultConfig } from '@web3modal/ethers5';
import { createAppKit } from '@reown/appkit';
import { Ethers5Adapter } from '@reown/appkit-adapter-ethers5';
import { mainnet,bsc } from '@reown/appkit/networks';
import { initVersePioneer,initVerseGenesis } from './customNetwork.js';
import { JsonRpcProvider, StaticJsonRpcProvider,Web3Provider } from "@ethersproject/providers";
import { supportNetworks } from "./customNetwork.js";

const projectId =  process.env.VUE_APP_PROJECTID;

// 2. Create wagmiConfig
const ethers5Adapter = new Ethers5Adapter();

// application's metadata object
const metadata = {
  name: 'Obsswap',
  description: 'InitVerse test chain swap',
  url: 'https://test.obsswap.org',
  icons: ['https://avatars.mywebsite.com/']
};
// const ethersConfig = defaultConfig({
//   /*Required*/
//   metadata,
//   /*Optional*/
//   enableWalletConnect: true,
//   enableEIP6963: true, // true by default
//   enableInjected: true, // true by default
//   enableCoinbase: false, // true by default
// });

let web3Modal = null;

function getInitGlobalWeb3Modal() {
  if (web3Modal) {
    return web3Modal;
  }
  // 3. create a AppKit instance
  web3Modal = createAppKit({
    adapters: [ethers5Adapter],
    metadata: metadata,
    networks: [initVerseGenesis,initVersePioneer],
    projectId:projectId,
    defaultNetwork:initVerseGenesis,
    allWallets: 'SHOW',
    allowUnsupportedChain:false,
    chainImages:{
      7234: 'https://www.clownwallet.com/res/ini.png',
      233: 'https://www.clownwallet.com/res/ini.png',
    },
    features: {
      swaps:false,
      onramp:false,
      send:false,
      history:false,
      email:false,
      socials:false,
      analytics: true,
    },
    themeVariables: {
      '--w3m-z-index':1000000,
    },
});

  return web3Modal;
};


let web3ModalProvider = null;

 function getWeb3ModalProvider(isReset) {

  if (web3ModalProvider && !isReset) {
    return web3ModalProvider;
  }

  const web3Modal = getInitGlobalWeb3Modal();  
  const isConnected = web3Modal.getIsConnectedState();
  const chainId = web3Modal.getChainId();
  if (isConnected && supportNetworks.includes(chainId)) {
    const walletProvider = web3Modal.getWalletProvider();
    web3ModalProvider = new Web3(walletProvider);
  }

  return web3ModalProvider;
};

// 传统的初始化web3Provider方法(该方式被抛弃)
  // if(walletType === '1' && typeof window.clowntion !== 'undefined') {
  //   web3ModalProvider = new Web3(window.clowntion.ethereum);
  // }else if (walletType === '2' && typeof window.okxwallet !== 'undefined') {
  //   web3ModalProvider = new Web3(window.okxwallet);
  // }else if (walletType === '3' && typeof window.ethereum !== 'undefined') {
  //   web3ModalProvider = new Web3(window.ethereum);
  // }

function disconnectWallet() {
  web3ModalProvider = null;
};

export const getChainID = () => {
  const web3Modal = getInitGlobalWeb3Modal();
  const chainId = web3Modal.getChainId();
  if (chainId && supportNetworks.includes(chainId)) {
    return chainId;
  }
  return null;
};

export const getCoinLogoUrl = () => {
  return `https://raw.githubusercontent.com/verse-extend/obsswap-tokenlist/main/assets/${getChainID()}/`;
};

export default {
  disconnectWallet,
  getWeb3ModalProvider,
  getInitGlobalWeb3Modal,
};







